<template>
  <div>
    <router-view />
  </div>
</template>

<script>
</script>

<style>
.el-pagination {
  justify-content: center;
}
body{
  margin: 0;
  padding: 0;
}
.fixed-pagination{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 20px 0;
}
</style>